interface HeaderSectionProps {
  label?: string;
  title: string;
  subtitle?: string;
  children?: React.ReactNode;
}

export function HeaderSection({
  label,
  title,
  subtitle,
  children,
}: HeaderSectionProps) {
  return (
    <div className="mb-4">
      <h2 className="text-2xl font-bold tracking-tight">{title}</h2>
      <p className="text-muted-foreground">{subtitle}</p>
    </div>
  );
}
